/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomfunnelaccounts3Inputs */

const en_liveroomfunnelaccounts3 = /** @type {(inputs: Liveroomfunnelaccounts3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounts made`)
};

const de_liveroomfunnelaccounts3 = /** @type {(inputs: Liveroomfunnelaccounts3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto erstellt`)
};

/**
* | output |
* | --- |
* | "Accounts made" |
*
* @param {Liveroomfunnelaccounts3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomfunnelaccounts3 = /** @type {((inputs?: Liveroomfunnelaccounts3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomfunnelaccounts3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomfunnelaccounts3(inputs)
	return de_liveroomfunnelaccounts3(inputs)
});
export { liveroomfunnelaccounts3 as "liveRoomFunnelAccounts" }